import { Booking, StatementBooking } from '@/types';

export const isTypeBooking = (
  booking: Booking | StatementBooking
): booking is Booking => {
  return Object.keys(booking).includes('consumer');
};
